import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify';
import { NeetQp } from '../Components/NeetQp';

export const QpView = () => {
    const {id} = useParams();
    const [allQs, setAllQs] = useState({
        type: "NEET",
        phy : [
            {id: 10}
        ],
        chem : [
            {id: 10}
        ],
        bio : [
            {id: 10}
        ]
    })
    const [fetched, setFetched] = useState(false);

    useEffect(() => {
      const tl = toast.loading("Please wait...");

      axios.get(`/qp?id=${id}`)
      .then(res=>{
        toast.dismiss(tl)
        setFetched(true);
        setAllQs(res.data)
      })
      .catch(er=>{
        toast.dismiss(tl);
        setFetched(true)
        toast.error("Internal Server Error");
      })
    }, [])
    
  return (
    <>
        {
            fetched
                && 
                <>
                    {allQs.type === "NEET" ? <><NeetQp qp={allQs}/></>: null}
                    {allQs.type === "JEE-Mains" ? <><NeetQp qp={allQs} /></>: null}
                </>
        }
    </>
  )
}
